<app-ng-select-typeahead [addTag]="addTag"
    [addTagText]="addTagText"
    [bindLabel]="bindLabel"
    [bindValue]="bindValue"
    [clearable]="clearable"
    [closeOnSelect]="_closeOnSelect"
    [clearChoicesOnLessMinTerm]="clearChoicesOnLessMinTerm"
    [clearSearchOnAdd]="clearSearchOnAdd"
    [dataApiGenerator]="dataGenerator"
    [dropdownPosition]="dropdownPosition"
    [multiple]="multiple"
    [ngSelectClass]="ngSelectClass + ' std-skin opened-search-icon'
      + (multiple ? ' bubble-dropdown' : '')"
    [placeholder]="(placeholder || '') | translate"
    [readonly]="readonly"
    [invalid]="invalid"
    [startWith]="startWith"
    [(ngModel)]="selected"
    (ngModelChange)="onValueChange($event)"
    (selectedValueChange)="onSelectedItem($event)"
    (dropdownClose)="onDropdownClose()">
  <ng-template appNgSelectOptionDirective
    let-item>
    <div id="item-filter"
        class="d-flex">
      <div *ngIf="showImage"
          class="col-auto d-flex align-items-center me-base-l8">
        <ng-container [ngTemplateOutlet]="conditionalImageTemp"
            [ngTemplateOutletContext]="{
              item: item,
              size: 32,
              imgClass: 'img-options-default'
            }">
        </ng-container>
      </div>
      <div class="col w-0">
        <label class="d-block fw-medium text-truncate mb-1">
          {{ getLabel(item) || '-' }}
        </label>
        <label *ngIf="bindSubLabel"
            class="d-block fs-base-l4 fw-normal text-truncate lh-sm mb-0">
          {{ getSubLabel(item) || '-' }}
        </label>
      </div>
    </div>
  </ng-template>
  <ng-template appNgSelectLabelDirective
      let-item>
    <div class="std-bubble p-0 border-0">
      <ng-container *ngIf="showImage">
        <ng-container [ngTemplateOutlet]="conditionalImageTemp"
            [ngTemplateOutletContext]="{
              item: item,
              size: 32,
              imgClass: 'img-options-default'
            }">
        </ng-container>
      </ng-container>
      <span class="text-truncate me-base-l8">
        {{ getLabel(item) }}
        <ng-container *ngIf="bindSubLabelInLabel"> ({{ getSubLabel(item) || '-' }})</ng-container>
      </span>
    </div>
  </ng-template>
  <ng-template appNgSelectMultiLabelDirective
    let-items
    let-clear="clear">
    <div *ngFor="let item of items"
        class="selected-item p-base-l12">
      <div class="std-bubble">
        <ng-container *ngIf="showImage">
          <ng-container [ngTemplateOutlet]="conditionalImageTemp"
              [ngTemplateOutletContext]="{
                item: item,
                size: 24,
                imgClass: 'img-bubble-label-default'
              }">
          </ng-container>
        </ng-container>
        <span class="text-truncate">
          {{ getLabel(item) }}
          <ng-container *ngIf="bindSubLabelInLabel"> ({{ getSubLabel(item) || '-' }})</ng-container>
        </span>
        <button type="button"
            class="btn-close custom-icon text-gray-pantone"
            aria-label="Close"
            (mousedown)="$event.stopPropagation()"
            (click)="clear(item)">
          <svg viewBox="0 0 24 24">
            <use href="assets/images/icons/marks/x.svg#x"
                height="24"
                width="24">
            </use>
          </svg>
        </button>
      </div>
    </div>
  </ng-template>
</app-ng-select-typeahead>
<ng-template #conditionalImageTemp
    let-item="item"
    let-size="size"
    let-imgClass="imgClass">
  <ng-container [ngSwitch]="getImageType(item)">
    <div *ngSwitchCase="'image'"
        [class]="imgClass"
        [ngClass]="getImageStyleClass(item)">
      <svg stroke="white"
          stroke-width="1.5"
          viewBox="0 0 24 24">
        <use [attr.href]="getImageSrc(item)"></use>
      </svg>
    </div>
    <app-profile-display *ngSwitchCase="'person'"
        [person]="item.context"
        [size]="size">
    </app-profile-display>
  </ng-container>
</ng-template>
